// src/components/pdf/styles.js
import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  // === PAGE ===
  page: {
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 25,
    paddingRight: 25,
    fontSize: 10,
    fontFamily: 'Helvetica',
    backgroundColor: '#FFFFFF',
  },

  // === TITRES ===
  mainTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1976D2',
    textAlign: 'center',
    marginBottom: 20,
  },

  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1976D2',
    marginTop: 20,
    marginBottom: 12,
    textAlign: 'center',
  },

  subsectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333',
    marginTop: 15,
    marginBottom: 8,
  },

  // === LAYOUT ===
  row: {
    flexDirection: 'row',
    marginBottom: 8,
  },

  column: {
    flex: 1,
  },

  twoColumns: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 20,
  },

  // === TEXTE ===
  text: {
    fontSize: 10,
    color: '#333',
    marginBottom: 4,
  },

  boldText: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#000',
  },

  label: {
    fontSize: 9,
    color: '#666',
    marginRight: 5,
  },

  value: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#000',
  },

  // === TABLEAUX ===
  table: {
    marginTop: 10,
    marginBottom: 10,
  },

  tableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #E0E0E0',
    paddingVertical: 6,
  },

  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#F5F5F5',
    borderBottom: '2px solid #1976D2',
    paddingVertical: 8,
    fontWeight: 'bold',
  },

  tableCell: {
    flex: 1,
    fontSize: 9,
    padding: 4,
  },

  // === CARTES INFO ===
  infoCard: {
    backgroundColor: '#F5F5F5',
    padding: 12,
    borderRadius: 4,
    marginBottom: 10,
  },

  matchInfo: {
    backgroundColor: '#E3F2FD',
    padding: 15,
    borderRadius: 4,
    marginBottom: 15,
  },

  playerCard: {
    backgroundColor: '#FFF',
    border: '2px solid #1976D2',
    padding: 12,
    borderRadius: 4,
    flex: 1,
  },

  // === STATS ===
  statRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
    paddingVertical: 4,
  },

  // 🆕 Version compacte pour les caractéristiques du match (espacement réduit de moitié)
  statRowCompact: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,  // 8 → 4 (divisé par 2)
    paddingVertical: 2,  // 4 → 2 (divisé par 2)
  },

  statLabel: {
    fontSize: 10,
    color: '#333',
    flex: 2,
  },

  statValue: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#1976D2',
    flex: 1,
    textAlign: 'right',
  },

  // === BARRES DE COMPARAISON ===
  comparisonContainer: {
    marginVertical: 6,
  },

  comparisonLabel: {
    fontSize: 9,
    color: '#333',
    marginBottom: 3,
  },

  comparisonBarRow: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 20,
  },

  comparisonValues: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 2,
  },

  comparisonValueLeft: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1976D2',
  },

  comparisonValueRight: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#FF6B6B',
  },

  // === GRAPHIQUES ===
  chartContainer: {
    marginVertical: 10,
    padding: 10,
    backgroundColor: '#FAFAFA',
    borderRadius: 4,
  },

  chartTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 8,
    textAlign: 'center',
  },

  // === UTILITAIRES ===
  spacer: {
    height: 10,
  },

  divider: {
    borderBottom: '1px solid #E0E0E0',
    marginVertical: 10,
  },

  center: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  // === COULEURS ===
  colorBlue: {
    color: '#1976D2',
  },

  colorRed: {
    color: '#FF6B6B',
  },

  colorGreen: {
    color: '#4CAF50',
  },

  colorOrange: {
    color: '#FF9800',
  },

  // === BADGES ===
  badge: {
    backgroundColor: '#1976D2',
    color: '#FFFFFF',
    padding: 4,
    borderRadius: 3,
    fontSize: 8,
    fontWeight: 'bold',
  },

  successBadge: {
    backgroundColor: '#4CAF50',
    color: '#FFFFFF',
    padding: 4,
    borderRadius: 3,
    fontSize: 8,
    fontWeight: 'bold',
  },

  warningBadge: {
    backgroundColor: '#FF9800',
    color: '#FFFFFF',
    padding: 4,
    borderRadius: 3,
    fontSize: 8,
    fontWeight: 'bold',
  },
});

export default styles;